module.exports = __webpack_public_path__ + "img/ambassadors-page-header-50-percent-benefit.abc780f2.svg";